var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4651 23.745L35.0101 14.82C34.7551 12.75 32.1901 12 30.4951 12H21.0301C20.7301 12 20.4601 12.075 20.2351 12.21L18.0751 13.5H15.4951C13.9051 13.5 12.4951 14.91 12.4951 16.5V22.5C12.4951 24.09 13.9051 25.53 15.4951 25.5H18.4951C19.8601 25.5 20.5801 26.175 22.0801 27.825C23.4451 29.325 23.4001 30.525 23.0251 32.73C22.9051 33.48 23.1151 34.23 23.6551 34.86C24.2401 35.565 25.1251 36 25.9951 36C28.7401 36 30.4951 30.435 30.4951 28.485L30.4651 27.015H33.5251C35.2651 27.015 36.4501 25.815 36.4951 24.06C36.4951 23.895 36.4651 23.745 36.4651 23.745ZM33.5101 25.53H30.5251C29.4751 25.53 28.9801 25.95 28.9801 26.985L29.0251 28.53C29.0251 30.435 27.2701 34.53 26.0251 34.53C25.2751 34.53 24.4051 33.78 24.5251 33.03C24.9001 30.66 25.0351 28.86 23.1901 26.82C21.6601 25.125 20.5351 24 18.4951 24V15L21.0001 13.5H30.4951C31.5901 13.5 33.4201 13.965 33.4951 15L33.5251 15.03L35.0251 24.03C34.9801 24.99 34.4551 25.53 33.5251 25.53H33.5101Z",
    fill: "#C53030"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#C53030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeOutline);
export default __webpack_public_path__ + "static/media/dislike-outline.b6eb0cb252ae9529e08cb5c919c89f4e.svg";
export { ForwardRef as ReactComponent };